import { compareBy, desc } from '../../utils/Comparator.js';
import { zip } from '../../utils/fp/zip.js';
import { jaroWinklerDistance } from '../../utils/jaroWinklerDistance.js';
import { joinMaps } from './joinMaps.js';
import { textRank } from './textRank.js';
import { tokenize } from './tokenize.js';
const JW_THRESHOLD = 0.8;
const RANK_EPS = 0.001;
export const search = (query) => (searchIndex) => {
    const { corpus, dictionary } = searchIndex || {};
    if (!query || !corpus?.length || !dictionary || !Object.keys(dictionary).length) {
        return [];
    }
    const queryTokens = tokenize(query);
    if (!queryTokens.length) {
        return [];
    }
    const dictEntries = Object.entries(dictionary);
    const pagesRanking = queryTokens
        .map(computePagesRankingPerToken(dictEntries))
        .reduce(joinMaps((a, b) => a + b, 0), new Map());
    const relevantPages = [...pagesRanking.entries()]
        .filter(([, pageRank]) => pageRank >= (JW_THRESHOLD - RANK_EPS) * queryTokens.length) // Multiplication of query tokens
        .map(([pageIndex]) => corpus[pageIndex]);
    return sortResultsByRank(queryTokens)(relevantPages);
};
const computePagesRankingPerToken = (dictEntries) => (qToken) => dictEntries
    .map(([stem, pageIndices]) => [jaroWinklerDistance(qToken)(stem), pageIndices])
    .filter(([stemRank]) => stemRank >= JW_THRESHOLD)
    .map(([stemRank, pageIndices]) => fillMapWith(pageIndices, stemRank))
    .reduce(joinMaps(Math.max, 0), new Map());
const sortResultsByRank = (queryTokens) => (results) => zip(results, results.map(({ title }) => title).map(textRank(queryTokens)))
    .sort(desc(compareBy(([, pageTitleRank]) => pageTitleRank)))
    .map(([corpusItem]) => corpusItem);
const fillMapWith = (keys, value) => new Map(keys.map((_) => [_, value]));
//# sourceMappingURL=search.js.map